import { render, staticRenderFns } from "./team-member-settings-header.vue?vue&type=template&id=80309010&scoped=true&"
import script from "./team-member-settings-header.vue?vue&type=script&lang=ts&"
export * from "./team-member-settings-header.vue?vue&type=script&lang=ts&"
import style0 from "./team-member-settings-header.vue?vue&type=style&index=0&id=80309010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80309010",
  null
  
)

export default component.exports